import { Component } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Router, ActivatedRoute } from '@angular/router';
import { ViewChild } from '@angular/core';


import { HttpClient } from '@angular/common/http';
import { environment } from '../../../environments/environment';
import { ToastrService } from 'ngx-toastr';


@Component({
  selector: 'app-reset-password',
  templateUrl: './reset-password.component.html',
  styleUrls: ['./reset-password.component.scss']
})

export class ResetPasswordComponent {

  public show: boolean = false;
  idOrganizacao: string = '';
  public loginForm: FormGroup;
  public isLoading:boolean = false;
  public nomeEmpresa: string = '';
  public token: string = '';


  constructor(private fb: FormBuilder, public router: Router,private route: ActivatedRoute,  private http: HttpClient, private toastr: ToastrService) {

    const userData = localStorage.getItem('token');
      if(userData?.length != null){
        router.navigate(['/maindashboard'])
      }

    this.loginForm = this.fb.group({
      email: ["", [Validators.required, Validators.email]],
      password: ["", [Validators.required]]
    });

  }


  ngOnInit() {
    this.route.queryParams.subscribe(params => {
      this.token = decodeURIComponent(params['token']);
    });
   }

  showPassword() {
    this.show = !this.show;
  }

  forgotPassword() {

      const body = {
        email: this.loginForm.value["email"],
        token: this.token,
        senha: this.loginForm.value["password"]
      };

      console.log(body);

      this.isLoading = true;
      this.http.post<any>(`${environment.apiUrl}/resetPassword`, body).subscribe((response) => {
        this.toastr.success('Senha alterada com sucesso!');
          this.router.navigate(["/"]);
          this.isLoading = false;

    }
    , (error) => {
          this.isLoading = false;
          console.error('Error:', error);
    });
  }

}
